import { render, staticRenderFns } from "./ClbrtnHist.vue?vue&type=template&id=7543b985&scoped=true"
import script from "./ClbrtnHist.vue?vue&type=script&lang=js"
export * from "./ClbrtnHist.vue?vue&type=script&lang=js"
import style0 from "./ClbrtnHist.vue?vue&type=style&index=0&id=7543b985&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7543b985",
  null
  
)

export default component.exports